import React, { useEffect, useState } from 'react';
import Tabs from '../../../../Components/Tabs'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Table from './Table'
import GetIcon from '../../../../utils/Icon'
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"

import { useGetDeliveryNoteMutation, useGetDeliveryNoteDocQuery, useLazyGetDeliveryNoteDocQuery } from '../../../../store/api/deliveryNoteApi'
import { usePostCreatePackingSlipMutation, usePostSubmitPackingSlipMutation, usePostGetPackingSlipByNameMutation, useLazyGetPackingSlipCountQuery, } from '../../../../store/api/packingSlip'
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import PrintModal from "../../../../../src/Core/Print/PrintModal";
import Attachment from '../../../../utils/Attachment';


function Createpackingslip({ deliveryNoteId, packing_slip }) {
    // function Createpackingslip() {

    //     const deliveryNoteId = 'DN-25-00067'

    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    const [activityboll, setactivityboll] = useState(false)
    const [tab, settab] = useState(1)
    const [item_Rows, setitem_Rows] = useState([]);
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [ptype, setptype] = useState("Error")
    const [loader, setloader] = useState(true)
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [scanInput, setScanInput] = useState("");
    const [save, setsave] = useState(false);
    const [pack_slip, setpack_slip] = useState('');
    const [fullDataState, setFullDataState] = useState(null);
    const [getPackingSlipByName] = usePostGetPackingSlipByNameMutation();
    const fulldata = []

    // const { data: fulldata, isLoading, isError, errorr, refetch } = useGetDeliveryNoteDocQuery(deliveryNoteId);

    // useEffect(() => {
    //     if (!isLoading && fulldata?.docs?.length) {
    //         setFullDataState(fulldata); 
    //         const updatedRows = fulldata.docs[0].items.map(item => ({
    //             ...item,
    //             scan_qty: 0,
    //         }));
    //         setItemList(updatedRows);

    //     } else {
    //         console.log("Waiting or no data", { isLoading, fulldata });
    //     }
    // }, [ ]);


    const [selectedItem, setSelectedItem] = useState(null);
    useEffect(() => {
        const fetchPackingSlip = async () => {
            const payload = {
                doctype: 'Packing Slip',
                name: packing_slip,
            };

            try {
                const response = await getPackingSlipByName(payload);
                console.log(response, "response_full");

                const message = response.data.message;
                console.log(message, "res_message");

                setFullDataState(message);

                const updatedItems = message.items.map(item => ({
                    ...item,
                    // scan_qty: 0,
                }));

                console.log(updatedItems, "updatedItems");

                setItemList(updatedItems);
            } catch (err) {
                console.error('Error fetching packing slip:', err);
            }
        };

        fetchPackingSlip();
    }, []);

    console.log(itemList, "itemList_came");

    console.log(fullDataState, "fullDataState_set");

    const handleScan = (scannedCode) => {
        setItemList(prevList => {
            let itemFound = false;
            let updatedItem = null;

            const updatedList = prevList.map(item => {
                if (item.item_code === scannedCode) {
                    itemFound = true;
                    if (item.scan_qty < item.qty) {
                        updatedItem = {
                            ...item,
                            scan_qty: parseInt(item.scan_qty) + 1
                        };
                        return updatedItem;
                    } else {
                        setptype("Error");
                        setError(`All quantities already scanned for item ${item.item_code}`);
                        setShowError(true);
                    }
                }
                return item;
            });

            if (itemFound && updatedItem) {
                // Move updated item to first position
                const newList = [
                    updatedItem,
                    ...updatedList.filter(i => i.item_code !== scannedCode)
                ];
                setSelectedItem(updatedItem); // if you're tracking it separately
                return newList;
            }

            if (!itemFound) {
                setTimeout(() => {
                    setptype("Error");
                    setError(`Item ${scannedCode} not found in the list`);
                    setShowError(true);
                }, 0);
            }

            return updatedList;
        });

        setTimeout(() => {
            setScanInput("");
        }, 400);
    };

    const [postCreatePackingSlip] = usePostCreatePackingSlipMutation();
    const handleSaveClick = async () => {
        try {
            const payloadItems = item_Rows

                .map(item => ({
                    item_code: item.item_code,
                    qty: Number(item.scan_qty)
                    // qty: item.qty

                }));
            console.log(payloadItems, "payloadItems");

            const payload = {
                delivery_note_id: deliveryNoteId,
                items: payloadItems
            };

            const response = await postCreatePackingSlip(payload).unwrap();
            if (response.result) {
                setError('Submited');
                setptype(`Packing Slip Created ${response.result.name} successfully:`);
                setShowError(true);

                setsave(false)
                setsave(true)
                console.log(response, "response_one");
                setpack_slip(response.result.name)
                setFullDataState(response)
                triggerGetCount(deliveryNoteId);


            }

        } catch (error) {
            console.error('Error creating packing slip:', error);
            alert('Failed to create packing slip');
        }
    };

    const [submitPackingSlip, { isLoadingtwo, isSuccess, isErrortwo, data, errorfour }] = usePostSubmitPackingSlipMutation();
    const [triggerGetCount, { data: countData, isLoading: countLoading, error: countError }] = useLazyGetPackingSlipCountQuery();

    const handleSubmit = async () => {
        try {
            const response = await submitPackingSlip({
                packing_slip_id: pack_slip
            }).unwrap();
            setError('Submited');
            setptype('Packing Slip  submitted successfully:');
            setShowError(true);
            setsave(false)
            const refetchResult = 0

            if (refetchResult?.data) {
                const freshData = refetchResult.data;
                setFullDataState(freshData);
                const updatedRows = freshData.docs[0].items.map(item => ({
                    ...item,
                    scan_qty: 0,
                    qty: item.qty - item.packed_qty
                }));
                setItemList(updatedRows);

                const allPacked = freshData.docs[0]?.items?.every(item => {
                    const qty = Number(item.qty);
                    const packed = Number(item.packed_qty);
                    return qty === packed;
                });

                console.log(allPacked, "✅ allPacked_after_submit");

                if (allPacked) {
                    console.log("✅ Navigating to packing slip page");
                    nvg('/outbound/outbound-packingslip', { state: { deliveryNoteId } });
                }
            }
            console.log('Submit Success:', response);
        } catch (err) {
            console.error('Submit Failed:', err);
        }
    };
    const lineCount = itemList.length;
    const totalQuantity = itemList.reduce((sum, item) => sum + (item.qty || 0), 0);
    const scannedQuantity = itemList.reduce((sum, item) => sum + parseInt(item.scan_qty || 0, 10), 0);
    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0"> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={17} /> </p>
                    <p className="m-0 breadcrumb-item"style={{cursor:"pointer"}} onClick={() => nvg("/outbound/outbound-packingslip")}>Packing Slip List  </p>
                    <p className="m-0">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={17} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        View Packing Slip
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {buttonData ? 'Submitted' : item ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                    <p className="p-0 m-0">
                        <img src={printerimg}
                            onClick={() => setShowPrintModal(true)}
                            className="px-2" style={{ width: '35px', cursor: 'pointer' }} alt="404" />
                    </p>
                </div>
            </div>

            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                          <Attachment doctype="Packing Slip"  docname={packing_slip}  /> 
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1 fullDataState={fullDataState} activityboll={activityboll} pack_slip={pack_slip} />

                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>



                        <div className="d-flex pb-2" style={{ gap: '5px' }}>
                            <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {lineCount}</span></p>
                            <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {totalQuantity}</span></p>

                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>

                        <Table

                            list_data={itemList}
                            fulldata={fulldata}
                            row={{ Rows: item_Rows, setRows: setitem_Rows, selectedItem }}
                            save={save}
                        />
                    </div>
                    {showPrintModal && (
                        <PrintModal
                            onClose={() => setShowPrintModal(false)}
                            documentId={fullDataState.name}
                            doctype="Packing Slip"
                            title="Print Packing Slip"
                        />
                    )}

                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={''}
                    onClose={() => setShowError(false)}
                />

            </div>
        </>
    )
}

export default Createpackingslip
